import { render } from "./IRPage.vue?vue&type=template&id=8678297c&scoped=true"
import script from "./IRPage.vue?vue&type=script&lang=js"
export * from "./IRPage.vue?vue&type=script&lang=js"

import "./IRPage.vue?vue&type=style&index=0&id=8678297c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8678297c"]])

export default __exports__